import type { IFlyersTabBrandsItemResources } from "@/src/flyers/FlyersTabBrandsItem.Resources";

export const FlyersTabBrandsItemResourcesEn: IFlyersTabBrandsItemResources = {
    newFlyerText: "New Flyer",
};
